<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="tabs != null && tabs.length > 0"
    :id="id"
    ref="container"
    class="tabs-slider-container"
    :class="{ disabled: isDisabled }"
    :style="`width: ${width}; height: ${height}`">
    <div class="track">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-container" />
    </div>
    <div
      class="selection-marker"
      :style="selectionMarkerStyle">
      <template v-if="showHandleBars">
        <div class="handle" />
        <div class="handle" />
      </template>
    </div>
    <div class="tabs">
      <div
        v-for="tab in tabs"
        :id="`tab_slider_${tab.id}`"
        :key="tab.id"
        v-tooltip="tab.tooltip"
        class="tab"
        :aria-disabled="tab.isDisabled || false"
        :style="tabStyle"
        :class="{
          'tab-borders': showDividers,
          selected: selectedTabInternal != null && selectedTabInternal.id === tab.id,
          'no-text': tab.name == null,
          disabled: tab.isDisabled || false,
        }"
        @click="(tab.isDisabled || false) === false ? selectTab(tab) : null">
        <div
          v-if="tab.icon != null && actualWidth > minWidthToShowIcons"
          class="icon">
          <component
            :is="toRaw(tab.icon)"
            :style="`width: ${iconWidth}; height: ${iconHeight}`" />
        </div>
        <span class="tab-name">{{ tab.name }}</span>
      </div>
    </div>
    <input
      type="hidden"
      name="selectedTabID"
      :value="selectedTabID" />
  </div>
</template>

<script type="text/babel">
  import { capitalize, toRaw } from 'vue';

  export default {
    props: {
      id: {
        type: String,
        default: null,
      },
      tabs: {
        type: Array,
      },
      selectedTabID: {
        type: String,
      },
      width: {
        type: String,
        default: '24rem',
      },
      height: {
        type: String,
        default: '4rem',
      },
      iconWidth: {
        type: String,
        default: '2rem',
      },
      iconHeight: {
        type: String,
        default: '2rem',
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      minWidthToShowIcons: {
        type: Number,
        default: 0,
      },
      tabStyle: {
        type: String,
      },
      minTabWidth: {
        type: String,
        default: null,
      },
      showHandleBars: {
        type: Boolean,
        default: true,
      },
      showDividers: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectedTabInternal: null,
        actualWidth: 0,
      };
    },
    computed: {
      selectionMarkerStyle() {
        const tabSize = 100 / this.tabs.length;
        const selectedTabIndex =
          this.selectedTabInternal != null
            ? this.tabs.indexOf(this.tabs.find((x) => x.id === this.selectedTabInternal.id))
            : 0;
        return `width: ${tabSize}%; left: ${selectedTabIndex * tabSize}%;`;
      },
    },
    watch: {
      selectedTabID() {
        this.selectedTabInternal =
          this.selectedTabID == null ? this.tabs[0] : this.tabs.find((x) => x.id === this.selectedTabID);
      },
    },
    mounted() {
      this.selectedTabInternal =
        this.selectedTabID == null ? this.tabs[0] : this.tabs.find((x) => x.id === this.selectedTabID);
      window.addEventListener('resize', () => {
        this.updateActualWidth();
      });
      this.updateActualWidth();
    },
    methods: {
      capitalize,
      toRaw,
      selectTab(tab) {
        if (this.isDisabled) {
          return;
        }
        this.selectedTabInternal = tab;
        this.$emit('selectedTabChanged', tab);
      },
      updateActualWidth() {
        if (this.$refs.container != null) {
          this.actualWidth = parseInt(this.$refs.container.offsetWidth, 10);
        }
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .tabs-slider-container {
    position: relative;
    overflow: hidden;
    border-radius: 0.5rem;

    &.disabled {
      .selection-marker {
        background-color: var(--textMutedColorExtraLight);
      }
      .tabs {
        .tab {
          cursor: not-allowed;
        }
      }
    }

    .track {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border: solid 0.1rem $borders;
      border-radius: 0.5rem;
      background-color: $almost-white;
      box-shadow: $inner-shadow-md;
      display: flex;
      align-items: center;

      .tab-container {
        flex-basis: 100%;
        height: 90%;

        /*
        border-right: solid 0.1rem $borders;
        border-left: solid 0.1rem white;

        &:first-of-type {
          border-left: none;
        }

        &:last-of-type {
          border-right: none;
        }
        */
      }
    }

    .selection-marker {
      background-color: var(--actionsColor);

      position: absolute;
      transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
      height: 100%;
      border: solid 0.1rem $borders;
      border-radius: 0.5rem;
      box-shadow: $shadow;

      .handle {
        position: absolute;
        width: 0.4rem;
        height: 60%;
        top: 20%;
        box-shadow: $small-shadow;

        border-left: solid 0.1rem var(--actionsColorReverseFaded);
        border-right: solid 0.1rem var(--actionsColorReverseFaded);

        &:first-of-type {
          left: 0.5rem;
        }

        &:last-of-type {
          right: 0.5rem;
        }
      }
    }

    .tabs {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;

      .tab {
        cursor: pointer;
        transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
        display: flex;
        flex-basis: 100%;
        align-items: center;
        justify-content: center;
        padding: 1.2rem 1.6rem;
        font-weight: 600;

        color: var(--textMutedColorExtraLight);

        .icon {
          display: flex;
          align-items: center;
          margin-right: 0.6rem;

          svg {
            fill: var(--textMutedColorExtraLight);
            stroke: var(--textMutedColorExtraLight);
          }
        }

        .tab-name {
          text-align: center;
        }

        &:hover {
          color: var(--actionsColor);

          svg {
            fill: var(--actionsColor);
            stroke: var(--actionsColor);
          }

          &.disabled {
            color: var(--textMutedColorExtraLight);

            svg {
              fill: var(--textMutedColorExtraLight);
              stroke: var(--textMutedColorExtraLight);
            }
          }
        }

        &.selected {
          transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);

          color: var(--actionsColorReverse);

          .icon {
            svg {
              fill: var(--actionsColorReverse);
              stroke: var(--actionsColorReverse);
            }
          }
        }

        &.no-text {
          .icon {
            margin-right: 0;
          }
        }
      }
      .tab:last-child {
        border-right: none;
      }
    }
    .tab-borders {
      border-right: solid 0.1rem $borders;
    }
  }
</style>
